<template>
  <n-modal class="page-record-create" :loading="$var('load')" @close="$emit('close')">
    <div class="line">
      <n-card class="info" :loading="$var('load')">
        <template #header>
          <h3>Информация</h3>
        </template>
        <n-items>
          <n-input title="Проект" :value="project.title" text />
          <n-input title="Дата заполнения" v-bind="$form.input('publishedAt')" />
        </n-items>
      </n-card>
    </div>
    
    <n-card :loading="$var('load')">
      <template #header>
        <h3>{{ journal.title }}</h3>
      </template>
      <n-items>
        <n-input title="№ п.п" v-bind="$form.input('number')" />
        <n-input title="Обозначение сварного соединения по исполнительному чертежу, тип сварного соединения" v-bind="$form.input('titleType')" />
        <n-input title="Ф.И.О.. сварщика, личное клеймо" v-bind="$form.input('welder')" />
        <n-input title="Марка стали (композиция марок стали), НТД, № сертификатов" v-bind="$form.input('steelMark')" />
        <n-input title="Наружный диаметр элемента трубопровода и толщина стенки Dn * S, мм" v-bind="$form.input('outDiameter')" />
        <n-input title="Дата сварки, температурные условия в рабочей зоне, С" v-bind="$form.input('weldingDate')" />
        <n-input title="Способ сварки" v-bind="$form.input('weldingType')" />
        <n-input title="Сварные материалы (марка электрода, сварочной проводки, защитный газ, флюс), НТД , № сертификатов" v-bind="$form.input('weldingMaterial')" />
        <n-input title="Режим предварительного и сопутствующего подогрева" v-bind="$form.input('heatingMode')" />
        <n-input title="Отметка о контроле корня шва" v-bind="$form.input('controleMark')" />
        <n-input title="Стилоскопирование металла шва, № заключения, дата" v-bind="$form.input('steeloscopy')" />
        <n-input title="Ф.И.О. оператора-термиста, личное клеймо" v-bind="$form.input('operator')" />
        <n-input title="№ диаграммы по журналутермообработки сварных соединений" v-bind="$form.input('diagramNumber')" />
        <n-input title="Замер твердости металла шва, № заключения, дата" v-bind="$form.input('steelHard')" />
        <n-input title="Отметка о годности сварного соединения по внешнему осмотру и измерениям" v-bind="$form.input('okMark')" />
        <n-input title="Способ и результат неразрушающего контроля сварного соединения, № заключения, дата" v-bind="$form.input('resultControl')" />
        <n-input title="Результаты замера феритной фазы в металле, № заключения, дата" v-bind="$form.input('result')" />
      </n-items>
    </n-card>
    
    <n-card>
      <n-divide>
        <div></div>
        <n-button color="success" @click="save">Сохранить</n-button>
      </n-divide>
    </n-card>
  </n-modal>
</template>

<script>
export default {
  name: 'PageRecordCreate',
  props: [ 'project', 'journal', ],
  data() {
    return {
      figures: [],
    }
  },
  created() {
    this.$form.init({
      publishedAt: $app.date.format($app.date.now()),
    })
  },
  methods: {
    save() {
      this.$var('load', true)
      const data = {
        record: this.$form.get(),
      }
      $api.journals.records.create(this.project.id, this.journal.name, data).then((response) => {
        this.$emit('reload')
        this.$emit('close')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .page-record-create {
    
    .line {
      display: flex;
      align-items: flex-start;
      
      & > * {
        white-space: normal;
        display: inline-block;
        margin-bottom: 0;
        flex-grow: .4;
        flex-basis: 1px;
      }
      .items {
        margin-left: 0;
        flex-grow: .6;
      }
    }
    
    
    .weather {
      .unit {
        margin: 0 20px 0 5px;
      }
      .temperature {
        margin-left: 20px;
      }
      .temperature, .wind {
        width: 100px;
      }
    }
    
    .add {
      margin-top: 5px;
      font-size: .8em;
      opacity: .7;
      cursor: pointer;
    }
  }
</style>
